import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import {Table} from 'react-bootstrap'
import Table from 'react-bootstrap/Table'
const Call_Logs=(props)=>{
    const [get_call_log_user_ad, setget_call_log_user_ad]=useState([])
    const get_call_log_user=()=>{
        axios.get('/get_call_log_user?user_id='+props.userData.id).then((res)=>{
          if(res.data){
            if(res.data.length!==0){
                setget_call_log_user_ad(res.data)
            }
          }
        })
      }
      const getdata=(ev)=>{
        let date_from=''
        if(ev){
          date_from=new Date(ev).toDateString()
        }
        return date_from
      }
      const gettime =(ev)=>{
        let time=''
        if(ev){
           time=new Date(ev).toLocaleTimeString('en',
          { timeStyle: 'short', hour12: true });
        }
        return time;
      }
      console.log(get_call_log_user_ad)
      useEffect(()=>{
          get_call_log_user()
      })
    return(
        <div className='ContainerCard'>
            <Table style={{
                display:'table',
                width:'100%'
            }} striped bordered hover responsive>
                <thead>
                    <tr>
                        {/*
                            <th>Created At</th>
                            <th>Created By</th>
                            <th>Id</th>
                            <th>Location Id</th>
                        */}
                        <th>Login Time</th>
                        <th>Logout Time</th>
                        {/*
                            <th>Remarks</th>
                            <th>Status</th>
                            <th>Updated At</th>
                            <th>Updated By</th>
                        */}
                        <th>User Id</th>

                    </tr>
                </thead>
                <tbody>
                    {get_call_log_user_ad.map((data, i)=>{
                        return(
                            <tr key={{i}}>
                                {/*
                                    <td>{getdata(data.created_at)} &nbsp; {gettime(data.created_at)}</td>
                                    <td>{data.created_by}</td>
                                    <td>{data.id}</td>
                                    <td>{data.location_id}</td>
                                */}
                                <td>{getdata(data.login_time)}&nbsp;{gettime(data.login_time)}</td>
                                <td>{getdata(data.logout_time)}&nbsp;{gettime(data.logout_time)}</td>
                                {/*
                                    <td>{data.remarks}</td>
                                    <td>{data.status}</td>
                                    <td>{getdata(data.updated_at)}&nbsp;{gettime(data.updated_at)}</td>
                                    <td>{data.updated_by}</td>
                                */}
                                <td>{data.user_id}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
        )
    }
export default Call_Logs;